import { render, staticRenderFns } from "./LtiLaunch.vue?vue&type=template&id=014b0efa&scoped=true&"
import script from "./LtiLaunch.vue?vue&type=script&lang=js&"
export * from "./LtiLaunch.vue?vue&type=script&lang=js&"
import style0 from "./LtiLaunch.vue?vue&type=style&index=0&id=014b0efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014b0efa",
  null
  
)

export default component.exports